import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import User from '../../models/user';

interface TermPlannerState {
    terms: [];
    weekdays: [];
    statuses: [];
    termPlan: any;
    termPlans: any;
}

const initialState: TermPlannerState = {
    termPlan: undefined,
    terms: [],
    weekdays: [],
    statuses: [],
    termPlans: [],
};

export const termPlanSlice = createSlice({
    name: 'term-planner',
    initialState: initialState,
    reducers: {
        setState: (state, action: PayloadAction<TermPlannerState>) => {
            state.terms = action.payload.terms;
            state.weekdays = action.payload.weekdays;
            state.statuses = action.payload.statuses;
            state.termPlan = action.payload.termPlan;
            state.termPlans = action.payload.termPlans;
        },
        setPlan(state, action: PayloadAction<any>) {
            state.termPlan = action.payload;
        }
    },
});

// Action creators are generated for each case reducer function
export const { setState, setPlan } = termPlanSlice.actions;

export default termPlanSlice.reducer;
